import {
	DEFAULT_TIME_ZONE_MODE,
	type TimeZoneMode,
	formatDateTime,
} from "./timeZone";

export type TooltipRow = {
	name: string;
	tagName: string;
	color: string;
	value: number | null;
	exact?: boolean;
	approximateAt?: number;
};

const buildLabel = ({ name, tagName }: TooltipRow) =>
	tagName && tagName !== name ? `${name} [${tagName}]` : name;

const formatTooltipValue = (value: unknown) => {
	if (value === null || value === undefined || value === "") {
		return "-";
	}

	const numericValue = Number(value);
	if (!Number.isFinite(numericValue)) {
		return String(value);
	}

	if (Number.isInteger(numericValue)) {
		return numericValue.toString();
	}

	return numericValue.toLocaleString(undefined, {
		maximumFractionDigits: 5,
	});
};

const buildMarker = (color: string) =>
	`<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${color};margin-right:5px;"></span>`;

export const buildTooltipHtml = (
	hoveredTime: number,
	rows: TooltipRow[],
	timeZoneMode: TimeZoneMode = DEFAULT_TIME_ZONE_MODE,
): string => {
	if (rows.length === 0) return "";

	const snapped = rows.some((row) => row.exact);

	const header = `<div style="font-weight: bold; margin-bottom: 5px;">${formatDateTime(
		hoveredTime,
		timeZoneMode,
		snapped,
	)}</div>`;

	return rows.reduce((html, row) => {
		const isApproximate = row.approximateAt !== undefined;

		const style = row.exact
			? ' style="font-weight:bold;"'
			: isApproximate
				? ' style="font-style:italic;"'
				: "";

		const suffix = isApproximate
			? ` [${formatDateTime(row.approximateAt as number, timeZoneMode, true)}]`
			: "";

		return `${html}<div${style}>${buildMarker(row.color)}${buildLabel(row)}: ${formatTooltipValue(
			row.value,
		)}${suffix}</div>`;
	}, header);
};
